import { Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { UserInfo, PublicHeader, Header2, Footer } from 'Components';
import { useIsDesktop, useIsOtpLogin } from 'Hooks';
import { BgDesk, BgMobile } from 'Images';
export const ErrorLayout = () => {
  const { isOtp, isAuth } = useIsOtpLogin();
  const isDesktop = useIsDesktop();

  return (
    <div
      style={{
        backgroundImage: isDesktop ? `url(${BgDesk})` : `url(${BgMobile})`,
        backgroundSize: 'cover',
      }}
    >
      {isOtp || !isAuth ? <PublicHeader /> : <Header2 />}
      {!isOtp && isAuth && <UserInfo />}
      <Container
        maxWidth={'lg'}
        sx={{
          overflow: 'hidden',
          minHeight: 'calc(100vh - 72px - 477px)',
          paddingX: isDesktop ? '' : '24px',
        }}
        component={'main'}
      >
        <Outlet />
      </Container>
      <Footer />
    </div>
  );
};
